import React, { Component } from 'react'
import { connect } from 'react-redux'
import { claimActions } from '../../../redux/actions'
import FormattedMessage from '../../../components/FormattedMessage/FormattedMessage'
import ClaimRewardCouponForm from '../../../components/Form/ClaimRewardCouponForm/ClaimRewardCouponForm'
import { findWebGL } from '../../../utilities/webGL'
import ProofOfPurchaseModal from '../../../components/Modal/ProofOfPurchaseModal/ProofOfPurchaseModal'

class ClaimCoupon extends Component {
  _handleSubmit = values => {
    const { claimTokenCode, claimCouponCode } = this.props
    const webGL = findWebGL()
    if (values.couponCode.length >= 20) {
      return claimTokenCode(values.couponCode.trim(), webGL)
    }
    return claimCouponCode(values.couponCode.trim(), webGL)
  }

  _handleCloseProofOfPurchaseModal = () => {
    const { clearProofOfPurchase } = this.props
    clearProofOfPurchase()
  }

  render() {
    const { proofOfPurchase } = this.props
    return (
      <div aria-labelledby="redemption-description-heading">
        <ProofOfPurchaseModal
          isOpen={proofOfPurchase}
          toggle={this._handleCloseProofOfPurchaseModal}
        />
        <h4 id="redemption-description-heading">
          <FormattedMessage id="page.redemptionPage.title.description" />
        </h4>
        <p>
          <FormattedMessage id="page.redemptionPage.title.note" />
        </p>
        <div className="row justify-content-center">
          <div className="col-md-8 col-xl-6">
            <ClaimRewardCouponForm onSubmit={this._handleSubmit} parentComponent="default" />
          </div>
        </div>
        <br />
        <br />
        <small className="text-muted font-italic pt-3">
          <p>
            <FormattedMessage id="page.redemptionPage.text.couponDisclaimer" />
          </p>
        </small>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  claimCouponCode: (...args) => dispatch(claimActions.claimCouponCode(...args)),
  claimTokenCode: (...args) => dispatch(claimActions.claimTokenCode(...args)),
  clearProofOfPurchase: () => dispatch(claimActions.clearProofOfPurchase()),
})

const mapStateToProps = state => ({
  proofOfPurchase: state.claimReducers.proofOfPurchase,
})

export default connect(mapStateToProps, mapDispatchToProps)(ClaimCoupon)
